<template>
  <div class="pa-4">
    <v-data-table
      :headers="headers"
      :items="taskList"
      :items-per-page="pagination.perPage"
      hide-default-footer
      no-data-text="暂无任务"
      class="lstTask paginated-table table-striped table-hover"
    >
      <template v-slot:top>
        <v-row justify="space-between">
          <v-toolbar flat height="70" style="margin-top:7px;width:100%;">
            <v-text-field
              v-model="pagination.queryName"
              class="filterValue"
              append-icon="mdi-magnify"
              label="请输入任务名称查询"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>
            <md-tooltip md-direction="top">按回车以检索</md-tooltip>
          </v-toolbar>
        </v-row>
      </template>
      <template v-slot:item.name="{ item, index }">
        <span>
          {{
          `${preName} ${currentProjectIndex}.${item.sortNum}&nbsp;&nbsp;&nbsp;&nbsp;${item.name}`
          }}
        </span>
      </template>
      <template v-slot:item.updatedAt="{ item }">
        <span>{{ convertTime(item.updatedAt) }}</span>
      </template>

      <template v-slot:item.option="{ item }">
      
        <v-btn 
        class="btnFlow" 
        icon
         color="success" 
         small
          @click.native="flowEdit(item)"
          >
          <span class="material-icons" style="font-size:18px;">share</span>
          <md-tooltip md-direction="top">{{course.hasAuthModify==true?'任务流程编辑':'任务流程查看'}}</md-tooltip>
        </v-btn>

        <v-btn
        v-if="course.hasAuthModify"
          v-hasPermi="['dev::task::copy']"
          class="btnTaskEdit copyTask"
          icon
          color="success"
          small
          @click.native="copyTask(item)"
        >
          <span class="material-icons" style="font-size:18px;">content_copy</span>
          <md-tooltip md-direction="top">复制任务</md-tooltip>
        </v-btn>

        <v-btn
        v-if="course.hasAuthModify"
          v-hasPermi="['dev::task::edit']"
          class="btnTaskEdit editTask"
          icon
          color="success"
          small
          @click.native="checkedTask(item)"
        >
          <span class="material-icons" style="font-size:20px;">edit</span>
          <md-tooltip md-direction="top">任务信息修改</md-tooltip>
        </v-btn>

        <v-btn
        v-if="course.hasAuthModify"
          v-hasPermi="['dev::task::remove']"
          class="btnTaskDel"
          icon
          color="error"
          small
          @click.native="handleDelete(item)"
        >
          <span class="material-icons" style="font-size:20px;">delete_forever</span>
          <md-tooltip md-direction="top">删除</md-tooltip>
        </v-btn>
      </template>
    </v-data-table>

    <div class="md-layout md-gutter">
      <div
        class="md-layout-item md-xlarge-size-90 md-large-size-90 md-medium-size-80 md-small-size-80 md-xsmall-size-80"
        style="margin-top: 15px"
      >
        <p class="card-category md-xsmall-size-100">{{ from + 1 }} 到 {{ to }} ，共 {{ taskTotal }}</p>
      </div>
      <div
        class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-20 md-small-size-20 md-xsmall-size-20"
      >
        <v-btn

        v-hasPermi="['dev::task:add']"
          v-if="taskAddBtn||course.hasAuthModify"
          class="btnTaskAdd"
          color="success"
          small
          @click.stop="showTaskInfo"
        >新增</v-btn>
      </div>
      <div
        class="md-layout-item md-xlarge-size-100 md-layout md-gutter md-alignment-center-center md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <pagination
          class="pagination-no-border pagination-success"
          v-model="currentPage"
          :per-page="pagination.perPage"
          :total="taskTotal"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import { mapGetters, mapState } from 'vuex';
import Swal from 'sweetalert2';
export default {
  components: { Pagination },
  computed: {
    ...mapGetters(['taskList', 'currentProjectIndex', 'course', 'project', 'taskTotal']),
    preName() {
      return this.course.childType === 'chapter' ? '章节' : '任务';
    },
    from() {
      return (this.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return this.currentPage * this.pagination.perPage;
    },
    currentPage: {
      get() {
        return this.$store.state.task.taskCurrentPage;
      },
      set(val) {
        this.$store.dispatch('task/setTaskCurrentPage', val);
        this.$store.dispatch('task/refreshTaskList');
      }
    }
  },
  data: () => ({
    taskAddBtn: true, //新增任务按钮隐藏或者显示，根据有没有章节来判断
    selectedItem: 1,
    items: [],
    headers: [
      { text: '任务名称', align: 'start', value: 'name', sortable: false },
      { text: '最后修改', align: 'start', value: 'updatedAt', sortable: false },
      { text: '编辑', align: 'center', value: 'option', width: '100px', sortable: false },
    ],
    currentSort: 'name',
    currentSortOrder: 'asc',
    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 15, 25],
      total: 0,
      queryName: '',
    },
    taskModeMap: {
      study: '学习',
      train: '练习',
      exam: '考核',
    },
  }),
  methods: {
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.$store.dispatch('task/refreshTaskList', Object.assign({}, this.pagination));
      }
    },

    convertTime(time) {
      if (!time) return '';
      const reg = time.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):\d{2}/);
      return `${reg[1]} ${reg[2]}`;
    },
    flowEdit(task) {
      let url = `${process.env.VUE_APP_TASK_FLOW_URL}/#/${task._id}?tab=${this.course.hasAuthModify}&token=${localStorage.getItem(
        'token'
      )}`;
      window.open(url, '_blank');
    },
    showSceneList() {
      this.$store.dispatch('editor/reverseDrawerStatus', true);
    },
    checkedTask(task) {
      this.$store.dispatch('task/setTaskInfo', Object.assign({}, task));
      this.$store.dispatch('task/reverseShowTaskEdit', true);
    },
   async copyTask(task) {
      let result = await Swal.fire({
        title: '复制信息',
        text: `${task.name} 确定要复制该任务?,请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        this.$store.dispatch('task/copyTask', Object.assign({}, task));
      
      } 
    },
    showTaskInfo() {
      this.$store.dispatch('task/reverseShowTaskAdd', true);
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        cancelButtonText: '取 消',
        confirmButtonText: '确 定',
        buttonsStyling: false,
        reverseButtons:true,  //反转按钮位置
      });

      if (result.value) {
        this.$store.dispatch('task/removeTask', item);
        this.$store.dispatch('task/refreshTaskList');
      }
    },
  },
  watch: {
    'pagination.currentPage': {
      handler(news) {
        console.log('加在页面')
        this.$store.dispatch('task/refreshTaskList', Object.assign({}, this.pagination));
      },
      deep: true,
    },
    taskTotal(news) {
      this.pagination.total = news;
    },
    course: {
      handler(news) {
        if (news && news.children.length > 0) {
          this.taskAddBtn = true;
        } else {
          this.taskAddBtn = false;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
/* 影响全局表格样式 */
@media (max-width: 599px) {
  table tbody tr > td {
    width: 100% !important;
  }

  .pagination-no-border {
    padding-left: 0px !important;
  }
  .pagination-no-border > li:first-child > a {
    padding: 0.5rem 0;
  }
  .pagination-no-border > li:last-child > a {
    padding: 0.5rem 0;
  }
}
@media (min-width: 599px) {
  /* 
    .mobileSmall{
      display: none;
      margin: 0;
    } */
  /* .NomobileSmall{
      display: block;
    } */
}
</style>


<style lang="scss" scoped>

@media (max-width:600px) {
   .pa-4{
        padding: 0px !important;
   }
   .filterValue{
    padding-right: 0px !important;
    padding-left: 0px  !important;
   }
  
}
//  @import "vue-material/src/theme/engine";
//  .md-layout-item {
//     height: 40px;
//     margin-top: 8px;
//     margin-bottom: 8px;

// span {
//   width: 100%;
//   height: 100%;
//   padding: 8px;
//   display: block;
//   // background: md-get-palette-color(teal, 200);
// }
// }
.btnTaskAdd {
  margin-top: 15px;
}
</style>

